import type { Icon } from "iconsax-react";
import { Building, Hashtag, Calendar, DocumentText1, UserTick, Buildings, Clock } from "iconsax-react";
import { formatDateForDisplay, formatDateHuman } from "@/shared/utils";
import type { OrganizationMe } from "../types";
import { ORGANIZATION_TYPE_EN_LABELS } from "../consts";

interface Props {
  data: OrganizationMe;
  locale: "ru" | "kk" | "en";
  title: string;
  labels: {
    name: string;
    bin: string;
    registrationNumber: string;
    organizationType: string;
    registrationDate: string;
    chiefName: string;
    createdAt: string;
  };
}

interface InfoRowProps {
  icon: Icon;
  label: string;
  value: string | null | undefined;
}

function InfoRow({ icon: IconComponent, label, value }: InfoRowProps) {
  if (value == null || value === "") return null;
  return (
    <div className="flex justify-between items-center gap-2 py-4 first:pt-0 last:pb-0 not-last:border-b surface-component-stroke">
      <div className="flex justify-start items-center gap-2">
        <div className="w-5 aspect-square flex shrink-0 justify-center items-center content-action-brand">
          <IconComponent size={18} color="currentColor" />
        </div>
        <span className="text-body-regular-md content-base-secondary">{label}</span>
      </div>
      <span className="text-body-bold-md content-base-primary text-right">{value}</span>
    </div>
  );
}

export default function OrganizationReadOnlySection({ data, locale, title, labels }: Props) {
  const organizationTypeLabel =
    locale === "en" ? ORGANIZATION_TYPE_EN_LABELS[data.organization_type] : data.organization_type_display[locale];

  return (
    <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
      <h2 className="text-body-bold-lg content-base-primary pb-3 border-b surface-component-stroke">{title}</h2>
      <div className="flex flex-col">
        <InfoRow icon={Building} label={labels.name} value={data.name} />
        <InfoRow icon={Hashtag} label={labels.bin} value={data.bin} />
        <InfoRow icon={DocumentText1} label={labels.registrationNumber} value={data.registration_number} />
        <InfoRow icon={Buildings} label={labels.organizationType} value={organizationTypeLabel} />
        <InfoRow
          icon={Calendar}
          label={labels.registrationDate}
          value={data.registration_date ? formatDateForDisplay(data.registration_date) : null}
        />
        <InfoRow icon={UserTick} label={labels.chiefName} value={data.chief_name} />
      </div>
    </div>
  );
}

